import React, { useState } from "react";
import { useParams } from "react-router-dom";
import DriverViewStatus from "./DriverViewStatus";
import ResendInvitation from "./ResendInvitation";
import UnlockLogin from "./UnlockLogin";
import Tab from "reusable/tab";
import DriverAlcoholSubmissionsTable from "./DriverViewTable/DriverAlcoholSubmissionsTable";
import DriverWorkingAttendanceTable from "./DriverViewTable/DriverWorkingAttendanceTable";
import DriverDetailTable from "./DriverViewTable/DriverDetailTable";
import DriverLicenseSubmissionsTable from "./DriverViewTable/DriverLicenseSubmissionsTable";
import DriverHealthCheckTable from "./DriverViewTable/DriverHeatlhCheckTable";
import DriverWorkingRecordTable from "./DriverViewTable/DriverWorkingRecordTable";
import { useTranslation } from 'react-i18next';
import { PAGE_TITLE_ID } from 'reusable/TableScroll';
import MonthNavigator from 'reusable/MonthNavigator';
import { businessMonth } from 'config/time';


const DriverView: React.FC = () => {
    const { t, i18n } = useTranslation('driver');
    const tabsData = [
        { label: `${t('view.alcohol-submission.title')}`, value: 'alcoholsubmission' },
        { label: `${t('view.working-attendance.title')}`, value: 'workingattendance' },
        { label: `${t('view.working-record.title')}`, value: 'workingrecord' },
        { label: `${t('view.license-submission.title')}`, value: 'licensesubmission' },
        { label: `${t('view.health-check.title')}`, value: 'healthcheck' },
        { label:`${t('view.driver-detail.title')}`, value: 'driverdetail' },
    ];
    const [activeTab, setActiveTab] = useState<string>(tabsData[0].value);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    // A36（2026-11-03 和田様の UAT）。上部の月の切り替えで選んだ月（`YYYY-MM`）。上部の数字と5つのタブ
    // （アルコール・勤怠・作業記録・免許証・健康点検）に共通で効かせ、タブを替えても保つ。
    const [month, setMonth] = useState(businessMonth);
    // 2026-11-04 PM。月の切り替えは、車両の点検履歴と同じく白い枠の中・表のすぐ上の行の左に置く（以前は画面の題の右）。
    // 各タブの表が自分の道具の行（ソート・エクスポートなど）の左に描く。月は今までどおりここで持つ。
    // 「ドライバー詳細」のタブは月で絞らない（プロフィールと今の状態）ので出さない（月で絞ると誤解させないため）。
    const monthNavigator = <MonthNavigator month={month} onChange={setMonth} />;

    const handleTabClick = (value: string) => {
        setActiveTab(value);
        setCurrentPage(1);
    };

    const { id } = useParams<{ id: string }>();

    return (
        <main className="px-4 py-3 space-y-3">
            {/* EV-310・PR #248 の Codex の指摘。表の外枠の読み上げの名前に使う画面の題の id。/driver/:id はこの画面を
                そのまま描く（一覧の components/Driver/index.tsx を通らない）ので、ここにも要る。1つの画面に1つだけ。 */}
            <h6 id={PAGE_TITLE_ID} className="font-bold text-title">{t('title.title')}</h6>
            <div className="flex">
                <DriverViewStatus id={id} month={month}/>
            </div>
            {/* BE-20-AC3。初回のパスワードを未設定の運転者にだけ「招待を再送」を出す。 */}
            <ResendInvitation id={id} />
            {/* BE-04 続き12（2026-10-15 PM 判断）。ログインがロックされている運転者にだけ「ログインのロックを解除」を出す。 */}
            <UnlockLogin id={id} />
            <div className="bg-white rounded-md px-4 py-2 space-y-2">
               {/* Tab Section */}
                <div>
                    <Tab tabs={tabsData} onTabClick={handleTabClick} />
                </div>
                {/* Loading Indicator */}
                <div>
                {loading ? (
                    <div className="flex justify-center items-center" style={{ height: '73vh' }}>
                        <div>{t('ui.loading', { ns: 'common' })}</div>
                    </div>
                ) : (
                    <div>
                    {/* Table Section */}
                        {activeTab === 'alcoholsubmission' && <DriverAlcoholSubmissionsTable id={id} month={month} monthNavigator={monthNavigator} />}
                        {activeTab === 'workingattendance' && <DriverWorkingAttendanceTable id={id} month={month} monthNavigator={monthNavigator} />}
                        {activeTab === 'workingrecord' && <DriverWorkingRecordTable id={id} month={month} monthNavigator={monthNavigator} />}
                        {activeTab === 'licensesubmission' && <DriverLicenseSubmissionsTable id={id} month={month} monthNavigator={monthNavigator} />}
                        {activeTab === 'healthcheck' && <DriverHealthCheckTable id={id} month={month} monthNavigator={monthNavigator} />}
                        {activeTab === 'driverdetail' && <DriverDetailTable id={id}/>}
                    </div>
                )}
                </div>
                
            </div>
        </main>
    );
};

export default DriverView;